export const sdkStyles = {
  default: {
    color: '#1B1B1B',
    fontSize: '14px',
    fontFamily: 'halyard-text',
    lineHeight: 18,
  },
  success: {
    color: '#1B1B1B',
  },
  error: {
    color: '#1B1B1B',
  },
  hidePlaceholder: false,
};
